<template>
    <section>
    <CampaignLocationDetailsModal
        :location="locationDetails"
    ></CampaignLocationDetailsModal>
    <Header 
    :header_page_data="headerPageData"
    ></Header>
      <section>
        <div class="container container-app">
            <section class="position-relative campaigns-container mt-5">
                <h3 class="notifications-title">{{ $t('locations_list.title') }}</h3>
                <div class="row">
                    <div class="col-12">
                        <img src="./../../assets/mini_marker.svg" alt="mini_marker"> {{ locations[0].location.properties.full_address }}
                    </div>
                </div>
                <div class="multiple-locations-scroll-container mt-4">
                    <div v-for="(location, index) in locations" class="row mb-2" :key="index">
                        <div class="col-2">
                            <div class="round-person-name" :style="'background: ' + listDesignColor[calculateColorListing(index)].background + ';  border: 2px solid #ffffff; box-shadow: 0 0 0 2px ' + listDesignColor[calculateColorListing(index)].border + ';'"><span :style="'color: ' + listDesignColor[calculateColorListing(index)].color + ';'">{{ location.name.substring(0,1).toUpperCase() }}</span></div>
                        </div>
                        <div class="col-5 mt-3 pl-0">
                            <div @click.prevent="showLocationDetails(location)" class="person-name ml-3 float-left cursor-pointer">{{ trimText(location.name, 30) }}</div>
                        </div>
                        <div class="col-5 mt-3">
                            <img @click.prevent="showLocationDetails(location)" class="float-right info-icon mr-3 cursor-pointer" src="./../../assets/info.svg" alt="info" />
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-12">
                        <button @click.prevent="goto('campaign-map', {campaign_id: currentCampaignComputed._id, campaign: currentCampaignComputed})" class="btn shadow btn-app btn-block primaryBackground">{{ $t('locations_list.back_to_map') }}</button>
                    </div>
                </div>
            </section>
        </div>
      </section>
      <CampaignFooter></CampaignFooter>
    </section>
</template>

<script>
    import Header from "./../layouts/Header";
    import CampaignFooter from "../layouts/CampaignFooter";
    import HelperMixin from "./../../mixins/HelperMixin";
    import CampaignLocationDetailsModal from "../modals/CampaignLocationDetailsModal";
    

    export default {
        name: "LocationsList",
        components: {Header, CampaignLocationDetailsModal, CampaignFooter},
        mixins: [HelperMixin],
        data() {
            return {
                locationDetails: {
                    name: '',
                    created_by: {
                        name: ''
                    }
                },
                locations: [],
                headerPageData: {
                    title: this.$store.getters["currentCampaign"].name,
                    search: {
                        show: true,
                        type_search: ''
                    },
                    settings: {
                        show: true,
                        campaign: this.$store.getters["currentCampaign"]
                    },
                    home: {
                        show: true,
                    },
                    profile: {
                        show: false
                    }
                },
            }
        },
        created() {
            if (typeof this.$route.params.locations == 'undefined') {
                this.goto('campaign-map', {campaign_id: this.$route.params.campaign_id});
            }
            this.locations = this.$route.params.locations;
            
        },
        mounted() {
        },
        computed: {
            offlineLocations() {
                return this.$store.getters["offlineLocations"];
            },
            currentRespondentComputed() {
                return this.$store.getters["currentRespondent"];
            },
            currentCampaignComputed() {
                return this.$store.getters["currentCampaign"];
            }
        },
        methods: {
            showLocationDetails(location) {
                this.locationDetails = location;
                if (location.created_by._id == this.$store.getters["user"]._id || this.$store.getters["currentCampaign"].owner_id == this.$store.getters["user"]._id) {
                    this.$store.dispatch('saveCurrentRespondent', {
                        currentRespondent: location
                    }).then(()=> {
                        this.goto('edit-location', {campaign_id: this.$store.getters["currentCampaign"]._id, location_id: location.location_id , respondent_id: location._id});
                    });
                } else {
                    $('#campaignLocationDetailsModal').modal('show');
                }
            },
        },
    };
</script>
